import { Multiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

// Pascal
// https://de.wikipedia.org/wiki/Pascal_(Einheit)
function KiloNewtonDividedByMetreSquared() {
  let dividedby = "/";
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} />
      {dividedby}
      <Unit unit={UnitBaseTypes.metre} exponent={2} />
    </>
  );
}

export default KiloNewtonDividedByMetreSquared;
